<div class="position-relative slider_box" [ngClass]="{'lf-after-bg': mode === 'header'}">

  <div class="d-flex align-items-center " [ngClass]="{'mb-3': mode != 'modal'}">
    <!-- Title -->
    <h6 *ngIf="hasTitle" class="txt-darkGray title_4 mb-0 pointer" (click)="goToBrowse()">
      {{ title | translate }}
      <span class="material-icons-outlined txt-darkGray font-28 ms-md-4 v-bot">chevron_right</span>
    </h6>

    <!-- Buttons -->
    <button
      class="btn btn-prev border-0 rounded-circle text-white p-0 lh-1 d-flex align-items-center justify-content-center aspect-ratio_1-1"
      (click)="previousItem();pauseIntervals()" [disabled]="indexArray[0] === 0 && !isInfiniteLoop"
      [ngClass]="[buttonClass, buttonPosition]" *ngIf="!itemLayout || (itemLayout && items.length > 2)">
      <span class="material-icons-outlined font-14">arrow_back_ios</span>
    </button>

    <button
      class="btn btn-next border-0 rounded-circle text-white p-0 lh-1 d-flex align-items-center justify-content-center aspect-ratio_1-1"
      (click)="nextItem();pauseIntervals()"
      [disabled]="indexArray[indexArray.length -1] === maximumOfItems -1  && !isInfiniteLoop"
      [ngClass]="[buttonClass, buttonPosition]" *ngIf="!itemLayout || (itemLayout && items.length > 2)">
      <span class="material-icons-outlined font-14">arrow_forward_ios</span>
    </button>
  </div>


  <!-- slider process -->
  <div class="overflow-hidden pt-1 row flex-nowrap" [@slider]="{value :indexArray[0], params: {marginWidth:animMargin}}"
       *ngIf="mode === 'slider'">
    <ng-container *ngFor="let item of items; trackBy: trackBy; let index = index">
      <div class="col-6" [ngClass]="{'col-md-4': !itemLayout}" #process_box *ngIf="indexArray.includes(index)">
        <app-process-box [process]="item"
                         [layoutMode]="itemLayout ? 'main-in_progress' : 'main-default'"></app-process-box>
      </div>
    </ng-container>
  </div>


  <!-- slider header -->
  <div class="d-flex w-100 overflow-hidden position-relative br-24 header_container bg-white"
       [@headerSlider]="indexArray[0]" *ngIf="mode === 'header'">
    <ng-container *ngFor="let item of items; trackBy: trackBy; let index = index">
      <div class="w-100 overflow-hidden header_box position-absolute h-100 d-flex flex-column"
           [style.backgroundImage]="'url(\''+ item.image +'\')'" *ngIf="indexArray.includes(index)">
        <div class="mobileFixWidth mt-auto d-flex flex-column text-white justify-content-sm-end h-100">
          <h6 class="semi-bold font-21">{{ (language == 'fr' ? item.title_fr : item.title_en) | translate }}</h6>
          <p class="w-50 mt-1 font-18">{{ (language == 'fr' ? item.sub_title_fr : item.sub_title_en) | translate }}</p>
         <button class="btn br-4 btn-yellow text-white w-fit-content px-3 mt-4 border-0"
                  *ngIf="item.btn_fr || item.btn_en"
                  (click)="goTo((language == 'fr' ? item.link_fr : item.link_en))">
            {{ (language == 'fr' ? item.btn_fr : item.btn_en) | translate }}
          </button>
        </div>
        <div class="position-absolute progress_bar" [style.width]="progressBarWidth + '%'"></div>
      </div>
    </ng-container>
  </div>


  <!-- slider modal photo -->
  <div
    class="d-flex w-100 overflow-hidden position-relative br-16 header_container img-carousel align-items-center justify-content-center"
    *ngIf="mode == 'modal'"
    [@headerSlider]="indexArray[0]">
    <ng-container *ngFor="let item of items; let index = index">
      <img src="{{item}}" alt="" class="d-block w-100 position-absolute img-cover" *ngIf="indexArray.includes(index)">
    </ng-container>
    <button class="btn position-absolute photo_close_btn border-0" (click)="dismissModal()">
      <span class="material-icons-outlined text-black">close</span>
    </button>
  </div>

  <!-- slider booking -->
  <div class="overflow-hidden pt-1 row flex-nowrap" *ngIf="mode === 'payout' || mode == 'certificate'"
       [@slider]="{value :indexArray[0], params: {marginWidth:animMargin}}">
    @if (mode == 'payout') {
      <ng-container *ngFor="let item of items; trackBy:trackBy; let index = index">
        <div #process_box [class]="numberOfDisplayedItems === 1 ? 'col-12' : 'col-6'"
             *ngIf="indexArray.includes(index)">
          <app-booking-card [style]="'shadow-none'" [booking]="item"></app-booking-card>
        </div>
      </ng-container>

    } @else {
      <ng-container *ngFor="let item of items; trackBy:trackBy; let index = index">
        <div #process_box [class]="numberOfDisplayedItems === 1 ? 'col-12' : 'col-6'"
             *ngIf="indexArray.includes(index)">
          <app-housing-certificate-card [certificate]="item" [showButton]="index == 0 && !item.deleted_at"></app-housing-certificate-card>
        </div>
      </ng-container>
    }


  </div>

</div>

